import { Button, Grid } from "@mui/material";

export default function DashboardButton({
  Icon,
  text,
  navigateTo,
  navigate,
  color,
  hoverColor,
}) {
  return (
    <>
      <Grid item xs={12} sm={6} md={4}>
        <Button
          fullWidth
          variant="contained"
          size="large"
          startIcon={<Icon sx={{ fontSize: { xs: 16, md: 20 } }} />}
          sx={{
            py: { xs: 1, md: 1.5 },
            fontSize: { xs: "0.875rem", md: "0.9375rem" },
            backgroundColor: color,
            "&:hover": { backgroundColor: hoverColor },
          }}
          onClick={() => navigate(navigateTo)}
        >
          {text}
        </Button>
      </Grid>
    </>
  );
}
